import type { SWRConfiguration } from "swr";
import type { ApiGetConfig, ApiQueryConfig } from "./types";

export const defaultConfig: ApiQueryConfig = {
  dedupingInterval: 30_000,
  errorRetryCount: 3,
  errorRetryInterval: 1_000,
  errorPresentation: "page",
  showErrorPageOn404: false,
  disableCache: true,
} as const;

export function mergeApiQueryConfig(config?: ApiQueryConfig): ApiQueryConfig {
  return {
    ...defaultConfig,
    ...config,
  };
}

export function getRequestConfig(disableCache = true) {
  if (!disableCache) return;

  return {
    headers: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0",
    },
  };
}

export function getSWRConfig(config?: ApiGetConfig): SWRConfiguration {
  const { withError, ...queryConfig } = config ?? {};
  const { immutable, disableCache, ...swr } = mergeApiQueryConfig(queryConfig);
  if (!immutable) return swr;

  return {
    ...swr,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  };
}
